/* "Notify me when back in-stock" buttons (Products & Collections, Nov 2 2026, v0.0.377; markup: snippets/mm-notify-stock.liquid).
   Loaded once on every page (snippets/mm-shrimp-free.liquid). Signed-in buttons carry the relay URL + daily pass (data-mir-url /
   data-mir-tok); the relay (tank-image-relay src/notify.js, POST /notify) keeps the sign-ups and emails the shopper once the item is back.
   The list of variants this shopper is waiting on is read once per page and cached in localStorage ("mm-bis-on") so the green state shows
   at once; Horizon swaps the buy box on variant change, so new buttons are painted by a MutationObserver. */
(function () {
  if (window.mmBis || location.pathname.indexOf("/products/") < 0) return; window.mmBis = 1;   /* product pages only (David) */
  var LS = "mm-bis-on", OFF = "Notify me when back in-stock", ON = "Signed up for stock notification", on = {}, synced = false;
  try { on = JSON.parse(localStorage.getItem(LS) || "{}") || {}; } catch (e) { on = {}; }
  function save() { try { localStorage.setItem(LS, JSON.stringify(on)); } catch (e) {} }
  function post(b, body) {
    return fetch(b.dataset.mirUrl + "/notify", { method: "POST", headers: { "Content-Type": "text/plain" }, body: JSON.stringify(Object.assign({ token: b.dataset.mirTok }, body)) })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); });
  }
  function setIds(ids) { on = {}; (ids || []).forEach(function (id) { on[id] = 1; }); save(); }
  function paint() {
    var bs = document.querySelectorAll("button.mm-bis");
    bs.forEach(function (b) {
      if (b.dataset.busy) return;
      var y = !!on[b.dataset.v], t = b.dataset.err ? "Couldn't sign you up. Tap to try again" : y ? ON : OFF;
      if (b.classList.contains("mm-bis--on") !== y) b.classList.toggle("mm-bis--on", y);
      if (b.getAttribute("aria-pressed") !== String(y)) b.setAttribute("aria-pressed", String(y));
      if (b.textContent !== t) b.textContent = t;
    });
    if (!synced) {
      var first = document.querySelector("button.mm-bis[data-mir-tok]");
      if (first) { synced = true; post(first, { op: "list" }).then(function (d) { setIds(d.ids); paint(); }).catch(function () {}); }
    }
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("button.mm-bis");
    if (!b) return;
    e.preventDefault();
    if (on[b.dataset.v] || b.dataset.busy) return;
    if (!b.dataset.mirTok) { location.href = "/customer_authentication/login?return_to=" + encodeURIComponent(location.pathname + location.search); return; }
    delete b.dataset.err; b.dataset.busy = "1"; b.textContent = "Signing you up…";
    post(b, { op: "add", v: b.dataset.v, h: b.dataset.h })
      .then(function (d) { setIds(d.ids); on[b.dataset.v] = 1; save(); })
      .catch(function (s) {
        if (s === 401) { location.href = "/customer_authentication/login?return_to=" + encodeURIComponent(location.pathname + location.search); return; }
        b.dataset.err = "1";
      })
      .then(function () { delete b.dataset.busy; paint(); });
  });
  var queued = false;
  new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; paint(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", paint); else paint();
})();
